import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { AppBar } from '@material-ui/core';
import { Toolbar } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import { translation } from '../i18n';
import { Search as SearchIcon } from '@material-ui/icons';
import { InputBase } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { IObservableValue, observe } from 'mobx';

type LocalStyles = 'appBar' | 'navIconHide' | 'toolbar' | 'grow' | 'search' | 'searchIcon' | 'inputRoot' | 'inputInput';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  appBar: {
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
  toolbar: theme.mixins.toolbar,
});

interface Props {
  handleDrawerToggle?: () => void,
  showSearch: boolean,
  getSearchText?: (searchText: string) => void,
  searchText: IObservableValue<string>
}

interface State {
  value: string
}

const WAIT_INTERVAL = 500;

type PropsWithStyle = WithStyles<LocalStyles> & Props;

class MyAppBar extends React.Component<PropsWithStyle, State> {
  public state = {
    value: ''
  };

  private timer: any = undefined;

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public componentDidMount(): void {
    observe(
      this.props.searchText,
      () => {
        this.setState({value: this.props.searchText.get()})
      }
    )
  }

  public render() {
    const {classes} = this.props;

    return (
        <AppBar className={classes.appBar} position={'relative'}>
          <Toolbar>
            {
              this.props.handleDrawerToggle &&
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.props.handleDrawerToggle}
                className={classes.navIconHide}
              >
                <MenuIcon/>
              </IconButton>
            }
            <Typography variant="h6" color="inherit" noWrap={true}>
              {translation.t('employeeAppraisal')}
            </Typography>
            {this.props.showSearch &&
            <>
              <div className={classes.grow} />
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  value={this.state.value}
                  placeholder={translation.t('actions.search')}
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  onChange={this.handleChange}
                />
              </div>
            </>}
          </Toolbar>
        </AppBar>
    )
  };

  private handleChange = (e: any) => {
    clearTimeout(this.timer);

    this.setState({value: e.target.value});

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
  };

  private triggerChange = () => {
    const {value} = this.state;

    if (this.props.getSearchText) {
      this.props.getSearchText(value);
    }
  }
}

export default withStyles(localStyles, {withTheme: true})(MyAppBar);
